import { render, staticRenderFns } from "./EntryButtons.vue?vue&type=template&id=f5e8a870"
import script from "./EntryButtons.vue?vue&type=script&lang=js"
export * from "./EntryButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports